import React from "react";
import { Link } from "react-router-dom";
import styles from "./CompassPolicy.module.css";
import { Container } from "../components/common/Container";

// Icon components
const DocumentTextIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    />
  </svg>
);

const CheckCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </svg>
);

const CubeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
    />
  </svg>
);

const CreditCardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
    />
  </svg>
);

const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
    />
  </svg>
);

const ShieldExclamationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9v3.75m0-10.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.75c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.249-8.25-3.286Zm0 13.036h.008v.008H12v-.008Z"
    />
  </svg>
);

const CircleStackIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
    />
  </svg>
);

const GiftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
    />
  </svg>
);

const SparklesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
    />
  </svg>
);

const LinkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
    />
  </svg>
);

const ExclamationTriangleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
    />
  </svg>
);

const ScaleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z"
    />
  </svg>
);

const WrenchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.75 6.75a4.5 4.5 0 0 1-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 1 1-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 0 1 6.336-4.486l-3.276 3.276a3.004 3.004 0 0 0 2.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852Z"
    />
  </svg>
);

const XCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </svg>
);

const GlobeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
    />
  </svg>
);

const ChatBubbleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
    />
  </svg>
);

const EnvelopeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
    />
  </svg>
);

const PuzzleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 0 0 .658-.663 48.422 48.422 0 0 0-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 0 1-.61-.58v0Z"
    />
  </svg>
);

const DocumentCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12"
    />
  </svg>
);

const ArrowLeftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
    />
  </svg>
);

const ListIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    />
  </svg>
);

interface SectionProps {
  id: string;
  number: string;
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({
  id,
  number,
  title,
  icon,
  children,
}) => (
  <section id={id} className={styles.section}>
    <div className={styles.sectionHeader}>
      <div className={styles.sectionIcon}>{icon}</div>
      <div className={styles.sectionTitleWrapper}>
        <div className={styles.sectionNumber}>Section {number}</div>
        <h2 className={styles.sectionTitle}>{title}</h2>
      </div>
    </div>
    <div className={styles.sectionBody}>{children}</div>
  </section>
);

interface ListItemProps {
  children: React.ReactNode;
}

const ListItem: React.FC<ListItemProps> = ({ children }) => (
  <li className={styles.listItem}>
    <span className={styles.listBullet} />
    <span>{children}</span>
  </li>
);

const sections = [
  { id: "acceptance", title: "Acceptance of Terms" },
  { id: "description", title: "Description of Service" },
  { id: "subscription", title: "Subscription Plans and Payment" },
  { id: "account", title: "Account Registration" },
  { id: "conduct", title: "User Conduct" },
  { id: "data", title: "Data and Content" },
  { id: "grandfathering", title: "Grandfathering Policy" },
  { id: "intellectual-property", title: "Intellectual Property" },
  { id: "third-party", title: "Third-Party Services" },
  { id: "warranties", title: "Disclaimer of Warranties" },
  { id: "liability", title: "Limitation of Liability" },
  { id: "modifications", title: "Modifications to Service" },
  { id: "termination", title: "Termination" },
  { id: "governing-law", title: "Governing Law" },
  { id: "disputes", title: "Dispute Resolution" },
  { id: "contact", title: "Contact Information" },
  { id: "severability", title: "Severability" },
  { id: "entire-agreement", title: "Entire Agreement" },
];

export const CompassTerms: React.FC = () => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <main id="main-content" className={styles.page} role="main" tabIndex={-1}>
      <Container maxWidth="md">
        <Link to="/compass" className={styles.backLink}>
          <ArrowLeftIcon />
          Back to Compass
        </Link>

        <header className={styles.header}>
          <div className={styles.iconWrapper}>
            <DocumentTextIcon />
          </div>
          <h1 className={styles.title}>Terms of Service</h1>
          <p className={styles.subtitle}>Compass App</p>
          <div className={styles.meta}>
            <span>Last Updated: {currentDate}</span>
            <span className={styles.metaDot} />
            <span>iOS Application</span>
          </div>
        </header>

        <nav className={styles.toc} aria-label="Table of Contents">
          <h2 className={styles.tocTitle}>
            <ListIcon />
            Table of Contents
          </h2>
          <ul className={styles.tocList}>
            {sections.map((section, index) => (
              <li key={section.id} className={styles.tocItem}>
                <a href={`#${section.id}`} className={styles.tocLink}>
                  <span className={styles.tocNumber}>
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  {section.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.content}>
          <Section
            id="acceptance"
            number="01"
            title="Acceptance of Terms"
            icon={<CheckCircleIcon />}
          >
            <p>
              By downloading, installing, or using the Compass mobile
              application ("App"), you agree to be bound by these Terms of
              Service ("Terms"). If you do not agree to these Terms, do not use
              the App.
            </p>
          </Section>

          <Section
            id="description"
            number="02"
            title="Description of Service"
            icon={<CubeIcon />}
          >
            <p>
              Compass is a habit tracking application that allows users to:
            </p>
            <ul className={styles.list}>
              <ListItem>Create and manage daily habits</ListItem>
              <ListItem>Track habit completions and streaks</ListItem>
              <ListItem>Set reminders for habits</ListItem>
              <ListItem>View progress statistics and visualizations</ListItem>
              <ListItem>Track habits by flexible frequency — daily, specific days, or X times per week, month, or year</ListItem>
              <ListItem>Get AI-powered personalized habit suggestions via the AI Habit Coach (premium)</ListItem>
            </ul>
            <p>
              The App offers both free and premium subscription tiers with
              different features.
            </p>
          </Section>

          <Section
            id="subscription"
            number="03"
            title="Subscription Plans and Payment"
            icon={<CreditCardIcon />}
          >
            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Free Tier</h3>
              <ul className={styles.list}>
                <ListItem>Create up to 5 habits</ListItem>
                <ListItem>All core tracking features</ListItem>
                <ListItem>Local data storage only</ListItem>
                <ListItem>No account required</ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Premium Tier</h3>
              <ul className={styles.list}>
                <ListItem>Create up to 100 habits</ListItem>
                <ListItem>Cloud sync across devices</ListItem>
                <ListItem>Automatic backup</ListItem>
                <ListItem>AI Habit Coach — up to 5 AI-generated habit suggestions per day</ListItem>
                <ListItem>Requires account creation</ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Pricing</h3>
              <ul className={styles.list}>
                <ListItem>
                  <strong>Monthly Subscription:</strong> $4.99 USD per month
                </ListItem>
                <ListItem>
                  <strong>Yearly Subscription:</strong> $39.99 USD per year
                  (save ~33%)
                </ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Payment Terms</h3>
              <ul className={styles.list}>
                <ListItem>
                  Payment is charged to your Apple ID account at confirmation of
                  purchase
                </ListItem>
                <ListItem>
                  Subscriptions automatically renew unless cancelled at least 24
                  hours before the end of the current billing period
                </ListItem>
                <ListItem>
                  Your account will be charged for renewal within 24 hours prior
                  to the end of the current period
                </ListItem>
                <ListItem>
                  You can manage and cancel subscriptions in your App Store
                  account settings
                </ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Refunds</h3>
              <p>
                Refund requests are handled by Apple according to their App
                Store policies. We do not directly process refunds.
              </p>
            </div>
          </Section>

          <Section
            id="account"
            number="04"
            title="Account Registration"
            icon={<UserIcon />}
          >
            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Premium Features</h3>
              <p>
                To access premium features including cloud sync, you must create
                an account using one of the following methods:
              </p>
              <ul className={styles.list}>
                <ListItem>Sign in with Apple</ListItem>
                <ListItem>Sign in with Google</ListItem>
                <ListItem>Email and password</ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>
                Account Responsibilities
              </h3>
              <ul className={styles.list}>
                <ListItem>
                  You are responsible for maintaining the confidentiality of
                  your account
                </ListItem>
                <ListItem>
                  You are responsible for all activities under your account
                </ListItem>
                <ListItem>
                  You must provide accurate and complete information
                </ListItem>
                <ListItem>
                  You must be at least 13 years old to create an account
                </ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Account Security</h3>
              <ul className={styles.list}>
                <ListItem>
                  Use a strong, unique password if using email/password
                  authentication
                </ListItem>
                <ListItem>
                  Notify us immediately of any unauthorized access to your
                  account
                </ListItem>
              </ul>
            </div>
          </Section>

          <Section
            id="conduct"
            number="05"
            title="User Conduct"
            icon={<ShieldExclamationIcon />}
          >
            <p>You agree NOT to:</p>
            <ul className={styles.list}>
              <ListItem>Use the App for any unlawful purpose</ListItem>
              <ListItem>
                Attempt to gain unauthorized access to any part of the App
              </ListItem>
              <ListItem>Interfere with or disrupt the App or servers</ListItem>
              <ListItem>
                Reverse engineer, decompile, or disassemble the App
              </ListItem>
              <ListItem>Share your account credentials with others</ListItem>
              <ListItem>
                Create multiple free accounts to circumvent habit limits
              </ListItem>
              <ListItem>
                Use the AI Habit Coach to attempt to generate harmful, illegal,
                or abusive content
              </ListItem>
            </ul>
          </Section>

          <Section
            id="data"
            number="06"
            title="Data and Content"
            icon={<CircleStackIcon />}
          >
            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Your Data</h3>
              <ul className={styles.list}>
                <ListItem>
                  You retain ownership of all habit data you create
                </ListItem>
                <ListItem>
                  <strong>Free tier:</strong> Data is stored locally on your
                  device only
                </ListItem>
                <ListItem>
                  <strong>Premium tier:</strong> Data is synced to secure cloud
                  servers (Firebase)
                </ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Data Portability</h3>
              <ul className={styles.list}>
                <ListItem>
                  Your local data can be deleted by uninstalling the App
                </ListItem>
                <ListItem>
                  Premium users can request deletion of cloud data by contacting
                  support
                </ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Backup Responsibility</h3>
              <ul className={styles.list}>
                <ListItem>
                  Free tier users are solely responsible for their data backup
                </ListItem>
                <ListItem>
                  Premium tier includes automatic cloud backup
                </ListItem>
              </ul>
            </div>
          </Section>

          <Section
            id="grandfathering"
            number="07"
            title="Grandfathering Policy"
            icon={<GiftIcon />}
          >
            <p>
              If you are an existing user with more than 5 habits when the
              subscription model was introduced:
            </p>
            <ul className={styles.list}>
              <ListItem>
                You retain access to all your existing habits on the free tier
              </ListItem>
              <ListItem>
                Your grandfathered limit equals your habit count at the time of
                update
              </ListItem>
              <ListItem>
                Creating new habits beyond the free tier limit requires a
                premium subscription
              </ListItem>
            </ul>
          </Section>

          <Section
            id="intellectual-property"
            number="08"
            title="Intellectual Property"
            icon={<SparklesIcon />}
          >
            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>App Ownership</h3>
              <p>
                The App, including its design, features, and content, is owned
                by Dixon App Development and protected by copyright and other
                intellectual property laws.
              </p>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>License Grant</h3>
              <p>
                We grant you a limited, non-exclusive, non-transferable license
                to use the App for personal, non-commercial purposes.
              </p>
            </div>
          </Section>

          <Section
            id="third-party"
            number="09"
            title="Third-Party Services"
            icon={<LinkIcon />}
          >
            <p>The App integrates with the following third-party services:</p>
            <ul className={styles.list}>
              <ListItem>Apple App Store (payments and subscriptions)</ListItem>
              <ListItem>
                Firebase (authentication and cloud storage for premium users)
              </ListItem>
              <ListItem>PostHog (anonymous analytics)</ListItem>
              <ListItem>
                Anthropic (Claude AI — powers AI Habit Coach for premium users)
              </ListItem>
              <ListItem>
                Apple Push Notification Service (habit reminders)
              </ListItem>
            </ul>
            <p>
              Your use of these services is subject to their respective terms
              and policies.
            </p>
          </Section>

          <Section
            id="warranties"
            number="10"
            title="Disclaimer of Warranties"
            icon={<ExclamationTriangleIcon />}
          >
            <div className={styles.notice}>
              <div className={styles.noticeIcon}>
                <ExclamationTriangleIcon />
              </div>
              <p>
                THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT
                WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
              </p>
            </div>
            <p>This includes but is not limited to:</p>
            <ul className={styles.list}>
              <ListItem>MERCHANTABILITY</ListItem>
              <ListItem>FITNESS FOR A PARTICULAR PURPOSE</ListItem>
              <ListItem>NON-INFRINGEMENT</ListItem>
              <ListItem>ACCURACY OR RELIABILITY OF DATA</ListItem>
            </ul>
            <p>We do not guarantee that:</p>
            <ul className={styles.list}>
              <ListItem>The App will be uninterrupted or error-free</ListItem>
              <ListItem>Defects will be corrected</ListItem>
              <ListItem>
                The App is free of viruses or harmful components
              </ListItem>
            </ul>
            <div className={styles.notice}>
              <p>
                <strong>AI-Generated Content Disclaimer:</strong> Habit
                suggestions provided by the AI Habit Coach are generated by
                artificial intelligence and are for informational purposes only.
                They do not constitute professional medical, nutritional,
                psychological, or financial advice. You are solely responsible
                for evaluating and implementing any suggestions.
              </p>
            </div>
          </Section>

          <Section
            id="liability"
            number="11"
            title="Limitation of Liability"
            icon={<ScaleIcon />}
          >
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, DIXON APP DEVELOPMENT
              SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
              CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO:
            </p>
            <ul className={styles.list}>
              <ListItem>Loss of data</ListItem>
              <ListItem>Loss of profits</ListItem>
              <ListItem>Loss of habits or streaks</ListItem>
              <ListItem>Interruption of service</ListItem>
            </ul>
            <div className={styles.infoCard}>
              <p>
                OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAID FOR THE
                APP IN THE 12 MONTHS PRECEDING THE CLAIM.
              </p>
            </div>
          </Section>

          <Section
            id="modifications"
            number="12"
            title="Modifications to Service"
            icon={<WrenchIcon />}
          >
            <p>We reserve the right to:</p>
            <ul className={styles.list}>
              <ListItem>Modify or discontinue the App at any time</ListItem>
              <ListItem>
                Change features, pricing, or subscription terms
              </ListItem>
              <ListItem>
                Changes to pricing will not affect your current billing period.
              </ListItem>
              <ListItem>Update these Terms</ListItem>
            </ul>
            <p>
              Material changes will be communicated through the App or via
              email. Continued use after changes constitutes acceptance of
              modified Terms.
            </p>
          </Section>

          <Section
            id="termination"
            number="13"
            title="Termination"
            icon={<XCircleIcon />}
          >
            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>By You</h3>
              <p>You may stop using the App at any time by:</p>
              <ul className={styles.list}>
                <ListItem>Uninstalling the App</ListItem>
                <ListItem>
                  Cancelling your subscription (if applicable)
                </ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>By Us</h3>
              <p>We may suspend or terminate your access if you:</p>
              <ul className={styles.list}>
                <ListItem>Violate these Terms</ListItem>
                <ListItem>Engage in fraudulent activity</ListItem>
                <ListItem>Abuse the service</ListItem>
              </ul>
            </div>
          </Section>

          <Section
            id="governing-law"
            number="14"
            title="Governing Law"
            icon={<GlobeIcon />}
          >
            <p>
              These Terms shall be governed by and construed in accordance with
              the laws of the State of North Carolina, United States, without
              regard to conflict of law principles.
            </p>
          </Section>

          <Section
            id="disputes"
            number="15"
            title="Dispute Resolution"
            icon={<ChatBubbleIcon />}
          >
            <p>
              Any disputes arising from these Terms or use of the App shall be
              resolved through:
            </p>
            <ol className={styles.numberedList}>
              <li>Good faith negotiation</li>
              <li>Binding arbitration (if negotiation fails)</li>
            </ol>
            <div className={styles.infoCard}>
              <p>
                You waive any right to participate in class action lawsuits.
              </p>
            </div>
          </Section>

          <Section
            id="contact"
            number="16"
            title="Contact Information"
            icon={<EnvelopeIcon />}
          >
            <p>For questions about these Terms, please contact:</p>
            <div className={styles.contactCard}>
              <div className={styles.contactIcon}>
                <EnvelopeIcon />
              </div>
              <div className={styles.contactDetails}>
                <p className={styles.contactLabel}>Dixon App Development</p>
                <a
                  href="mailto:dixonappdevelopment@gmail.com"
                  className={styles.contactEmail}
                >
                  dixonappdevelopment@gmail.com
                </a>
              </div>
            </div>
          </Section>

          <Section
            id="severability"
            number="17"
            title="Severability"
            icon={<PuzzleIcon />}
          >
            <p>
              If any provision of these Terms is found unenforceable, the
              remaining provisions will continue in full force and effect.
            </p>
          </Section>

          <Section
            id="entire-agreement"
            number="18"
            title="Entire Agreement"
            icon={<DocumentCheckIcon />}
          >
            <p>
              These Terms, together with our{" "}
              <Link to="/compass/privacy" className={styles.link}>
                Privacy Policy
              </Link>
              , constitute the entire agreement between you and Dixon App
              Development regarding the App.
            </p>

            <div className={styles.summary}>
              <div
                className={`${styles.summaryCard} ${styles.summaryCardPremium}`}
              >
                <p>
                  By using Compass, you acknowledge that you have read,
                  understood, and agree to be bound by these Terms of Service.
                </p>
                <p style={{ marginTop: "1rem" }}>
                  <strong>
                    Copyright {new Date().getFullYear()} Dixon App Development.
                    All rights reserved.
                  </strong>
                </p>
              </div>
            </div>
          </Section>
        </div>
      </Container>
    </main>
  );
};
